import React from 'react'
import { useIntl } from 'react-intl'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'

interface Props {
  insuranceUpsellData: App.InsuranceUpsell
  variant?: 'compact' | 'default'
  onDismiss?: () => void
}

function InsuranceUpsellTile(props: Props) {
  const {
    insuranceUpsellData,
    variant = 'default',
    onDismiss,
  } = props
  const intl = useIntl()

  const {
    fetchingQuotes,
    fetchingLuxPlusSubscription,
    cheapestQuotePrice,
    cheapestQuoteLuxPlusPrice,
    isEnabledLuxPlusDiscountedInsurance,
    orderId,
  } = insuranceUpsellData

  return <OrderUpsellTileWithTracking
    title={intl.formatMessage({
      id: '+MW3yHw+nH',
      defaultMessage: 'Travel protection',
      description: 'Title for travel insurance upsell tile on booking confirmation',
    })}
    description={intl.formatMessage({
      id: 'PJu1Vz0xmU',
      defaultMessage: 'Be covered for medical, cancellations and lost baggage.',
      description: 'Description for travel insurance upsell tile on booking confirmation',
    })}
    price={cheapestQuotePrice}
    luxPlusPrice={cheapestQuoteLuxPlusPrice}
    priceUnit="person"
    isPriceLoading={fetchingQuotes || (isEnabledLuxPlusDiscountedInsurance && fetchingLuxPlusSubscription)}
    currencyFormat="dynamicDollar"
    IconComponent={LineShieldCheckIcon}
    to={`/travel-protection/add?orderId=${orderId}`}
    analyticsSubject="insurance"
    className="insurance-upsell-tile"
    variant={variant}
    onDismissClick={onDismiss}
  />
}

export default InsuranceUpsellTile
